module.exports = __webpack_public_path__ + "static/media/reporte_pagos_2.fe27ac9a.jpg";